import { render, staticRenderFns } from "./PackageVersionDropdownField.vue?vue&type=template&id=4abaa131"
import script from "./PackageVersionDropdownField.vue?vue&type=script&lang=ts"
export * from "./PackageVersionDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4abaa131')) {
      api.createRecord('4abaa131', component.options)
    } else {
      api.reload('4abaa131', component.options)
    }
    module.hot.accept("./PackageVersionDropdownField.vue?vue&type=template&id=4abaa131", function () {
      api.rerender('4abaa131', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/PackageVersionDropdownField.vue"
export default component.exports